<template>
  <ReviewGroup class="iv-scoring" :tableData="configData">
    <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-12">评审打分</h1>
    <p class="iv-m-t-24 iv-enroll-content-desc iv-fs-16 iv-fc-65">
      <span>打分说明：</span>
      <span v-html="reviewGroupInfo.scoreExplain"></span>
    </p>
    <div class="iv-m-t-24 iv-text-right iv-pos-r">
      <Button type="publicity" v-if="isShowPublishBtn && type != 'see'" @click="groupPublish">
        {{publicState == '1' ? '取消公示' : '组内公示'}}
      </Button>
      <Button type="review" class="iv-m-l-8" v-if="isShowEval && type != 'see'" @click="createEval">发起复评</Button>
      <Button type="submit" class="iv-m-l-8" @click="submitResult" v-if="isShowSubmitBtn && type != 'see'">提交评审结果</Button>
      <!-- <Button type="fullScreen" class="iv-m-l-8">全屏显示明细</Button> -->
    </div>
    <DragTable
      class="iv-m-t-12 iv-p-b-40"
      noSearch
      :showPage="false"
      :showEdit="false"
      :showDelete="false"
      :showSelect="type != 'see'"
      ref="DragTable"
      :immediateForce="true" 
      :columns="columns"
      :disabledDrag="false"
      @on-selection-change="changeSelect"
      :tableData="tableData">
    </DragTable>
    <OpinionModal ref="OpinionModal" @on-confirm="getReviewRuselt" :reviewGroupInfo="reviewGroupInfo" :dictCode="dictMap"></OpinionModal>
  </ReviewGroup>
</template>

<script>
import OpinionModal from './modal'
import resultCoulmn from './result-column'
import IconFont from '@/components/iconfont'
import ReviewGroup from '../components/review-group'
import DragTable from '@/components/drag-table-inline'
import { get, reportResult, updatePublicState, repetition, order, listResult } from '../interface'
import { getSignUpId } from '@/views/project-declare/sbgl-interface/index.js'

export default {
  data () {
    return {
      tableData: [],
      currentIndex: 0,
      isScoring: true,
      columns: [],
      configData: [],
      dictMap: {}, //数据字典
      reviewGroupInfo: {}, //评审组信息
      isShowSubmitBtn: false, //提交评审结果
      isShowPublishBtn: false, //组内公示
      isShowFillOpinion: false, //填写意见
      isShowEval: false, //复评
      checkList: [],
      rankCode: ''
    }
  },
  async created () {
    this.userId = this.$decode(sessionStorage.getItem('userId'))
    this.reviewTeamId = this.$decode(this.$route.query.reviewTeamId)
    this.reviewInfoId = this.$decode(this.$route.query.reviewInfoId)
    this.publicState = this.$decode(this.$route.query.publicState)
    this.businessCode = this.$decode(this.$route.query.businessCode)
    this.businessId = this.$decode(this.$route.query.businessId)
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    this.type = this.$decode(this.$route.query.type)
    await this.getRevireGroupInfo()
    //只有定级才会请求数据字典
    if (this.reviewGroupInfo.scoringMethod === 'DFFS03') {
      await this.getCodeTable(this.rankCode)
      this.setDynamicColumns()
    }
    this.getReviewRuselt()
    this.jumpMap = {
      'BOE_REPORT_LIST': 'projectDetail',
      'BOE_EVENT_INFO': 'activityDetail'
    }
    //以BOE_EVENT_INFO开头的是活动
    if (/^BOE_EVENT_INFO/.test(this.businessCode)) {
      this.jumpMap[this.businessCode] = 'activityDetail'
    }
  },
  provide () {
    return {
      expandParent: (type, item) => {
        //填写意见
        if (type === 'opinion') {
          item.isReadOnly = this.type === 'see' ? true : false
          this.$refs.OpinionModal.open(item)
        } else if (type == 'view') {
          // 校验评审对象是否存在
          getSignUpId ({listItemId: item.objectId}).then(async ({data}) => {
            if (!data.signUpId) return this.$Message.error('评审对象已改变，未找到该记录！')
            this.$router.push({
              name: this.jumpMap[this.businessCode] || 'appraisingDetail',
              query: {
                objectId: this.$encode(item.objectId),
                type: this.$encode('see'),
                score: this.$encode('result'),
                reviewTeamId: this.$encode(this.reviewTeamId),
                businessCode: this.$encode(this.businessCode),
                reviewRoundId: this.$encode('123'),
                reviewDetailId: this.$encode(item.reviewDetailId),
                reportState: this.$encode(this.reportState),
                applicationInfoId: this.$encode(item.reviewDetailId),
                backUrl: 'reviewGrade',
                businessId: this.businessId,
                bizLineCode: this.$encode(this.bizLineCode)
              }
            })
          })
        }
      },
      setSortIndex: this.sortChange
    }
  },
  methods: {
    //排序
    sortChange (o, n, oldItem, newItem) {
      order({reviewObjectId1: oldItem.reviewObjectId, reviewObjectId2: newItem.reviewObjectId}).then(({data}) => {
        this.$Message.success('排序成功')
        this.getReviewRuselt()
      })
    },
    changeSelect (list) {
      this.checkList = list
    },
    //发起复评
    createEval () {
      if (!this.checkList.length) return this.$Message.warning('请选择数据')
      const reviewObjectIds = this.checkList.map(item => item.reviewObjectId)
      repetition({reviewObjectIds: reviewObjectIds}).then(({data}) => {
        this.$Message.success('发起复评成功')
        this.back()
      })
    },
    //组内公示 、取消公示
    groupPublish () {
      updatePublicState({reviewInfoId: this.reviewInfoId, publicState: this.publicState == '1' ? '0' : '1'}).then(({data}) => {
        this.$Message.success(`${this.publicState == '1' ? '取消公示' : '公示'}成功`)
        this.back()
      })
    },
    //提交评审结果
    submitResult () {
      reportResult({reviewInfoId: this.reviewInfoId}).then(({data}) => {
        this.$Message.success('提交成功')
        this.back()
      })
    },
    //获取评审结果信息
    getReviewRuselt () {
      listResult({reviewInfoId: this.reviewInfoId}).then(({data}) => {
        this.tableData = data.map(item => {
          if (item.rankList && item.rankList.length) {
            item.rankList.forEach(val => {
              if (!item[val.dataCode]) {
                item[val.dataCode] = val.dataNum
              }
            })
          }
          return {
            ...item,
            isShowFillOpinion: this.isShowFillOpinion
          }
        })
      })
    },
    //获取评审组信息
    getRevireGroupInfo () {
      return new Promise((resolve, reject) => {
        get({reviewTeamId: this.reviewTeamId}).then(({data}) => {
          this.configData = data.members.map(item => ({
            ...item,
            operateAuthority: item.operateAuthority ? item.operateAuthority.split(',') : []
          }))
          const currentUserAuthority = data.members.find(v => v.memberUserId == this.userId)
          if (currentUserAuthority) {
            const auths = currentUserAuthority.operateAuthority.split(',')
            if (auths.includes('CZQX02')) {
              this.isShowEval = true
            }
            if (auths.includes('CZQX03')) {
              this.isShowPublishBtn = true
            }
            if (auths.includes('CZQX04')) {
              this.isShowFillOpinion = true
            }
            if (auths.includes('CZQX05')) {
              this.isShowSubmitBtn = true
            }
          }
          this.rankCode = data.scoreFieldDict
          this.reviewGroupInfo = data
          if (this.reviewGroupInfo.scoreExplain) {
            this.reviewGroupInfo.scoreExplain = this.reviewGroupInfo.scoreExplain.replaceAll('\n', '<br />')
          }
          this.columns = resultCoulmn.call(this)
          resolve()
        })
      })
    },
    //动态生成列
    setDynamicColumns () {
      const obj = this.dictMap[this.rankCode]
      this.columns.splice(3, 0, ...Object.keys(obj).map(item => {
        return {
          title: obj[item],
          width: obj[item].length < 3 ? 60 : 80,
          [$field]: item
        }
      }))
    },
    //获取数据字典  
    getCodeTable (code) {
      if (!code) return
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = {}
          data.data.length && data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    },
    //返回
    back () {
      this.$router.push({
        name: 'reviewList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    }
  },
  components: {
    OpinionModal,
    IconFont,
    DragTable,
    ReviewGroup
  }
}
</script>

<style lang="scss" scoped>
.iv-scoring {
  .iv-enroll-content-ul {
    overflow: hidden;
    li {
      width: 282px;
      padding: 18px 26px;
      border-radius: 16px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 24px;
      .iv-enroll-content-ul-tip {
        position: absolute;
        top: -28px;
        left: 26px;
        color: #FA2900;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      &:hover {
        font-weight: bold;
        color: #FA2900 !important;
        border-color: #FA2900;
      }
      &.iv-enroll-active {
        font-weight: bold;
        color: #FA2900 !important;
        border-color: #FA2900;
      }
    }
    .iv-disabled {
      cursor: not-allowed;
      background-color: #F5F7FA !important;
      border-color: rgba(0, 0, 0, 0.15) !important;
      color: rgba($color: #000000, $alpha: 0.25) !important;
      &:hover {
        font-weight: normal !important;
        color: rgba($color: #000000, $alpha: 0.25) !important;
        border-color: rgba(0, 0, 0, 0.15) !important;
      }
    }
  }
  .iv-enroll-content-desc {
    display: flex;
    background-color: #F5F7FA;
    border-radius: 16px;
    padding: 20px 24px;
  }
  .iv-enroll-tip {
    position: absolute;
    top: -24px;
    right: 20px;
    color: #FA2900;
  }
  .iv-en-grey {
    background-color: #F5F7FA !important;
    border-color: rgba(0, 0, 0, 0.15) !important;
    color: rgba($color: #000000, $alpha: 0.25) !important;
  }
}
</style>